import React from "react";

export const Connect: React.FC = () => {
  return null;
};
